import React from 'react';

import { Modal } from '../../../../../../../components';
import Button from '../../../../../../../components/Button';
import { CircularGreenBox } from '../../../../../../../assets/base64Images/search-user/circular-green-box';
import SquadBoldText from '../../../../../../../components/Text/SquadBoldText';
import SquadRegularText from '../../../../../../../components/Text/SquadRegularText';
import PingFangSemiBoldText from '../../../../../../../components/Text/PingFangSemiBoldText';
import PingFangRegularText from '../../../../../../../components/Text/PingFangRegularText';
import ColumnCenter from '../../../../../../../components/Layout/ColumnCenter';
import RowBetween from '../../../../../../../components/Layout/RowBetween';

const ConfirmUserModal: React.FC<Props> = ({
  callback,
  onClose,
  isEnglish,
  userName,
  phoneNumber,
  roomNo,
  location,
}) => {
  const contentWidth = 275;
  return (
    <Modal
      style={{ width: contentWidth, minWidth: 'unset', padding: 'unset', paddingBottom: 13, borderRadius: 42 }}
    >
      <ColumnCenter style={{ width: contentWidth }}>
        {/* 图标 */}
        <div>
          <img src={CircularGreenBox} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
        </div>

        {
          isEnglish ? (
            <SquadBoldText fontSize={22} lineHeight={29} marginTop={15}>
              Confirmation
            </SquadBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={22} lineHeight={29} marginTop={15}>
              确认
            </PingFangSemiBoldText>
          )
        }
        {
          isEnglish ? (
            <SquadRegularText fontSize={16} lineHeight={21} textAlign={'center'} marginTop={10} width={contentWidth * 0.9}>
              Please confirm that these details match the details on the delivery app or docket.
            </SquadRegularText>
          ) : (
            <PingFangRegularText fontSize={16} lineHeight={23} textAlign={'center'} marginTop={10} width={contentWidth * 0.9}>
              请确认这些细节与送货应用程序或交货单上的细节相匹配。
            </PingFangRegularText>
          )
        }

        <div style={{ width: contentWidth * 0.9, height: 1, backgroundColor: '#11202B', opacity: 0.1, marginTop: 25 }} />

        <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
          {
            isEnglish ? (
              <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                Name
              </SquadRegularText>
            ) : (
              <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                名字
              </PingFangRegularText>
            )
          }
          <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
            {userName}
          </SquadBoldText>
        </div>

        {
          phoneNumber && (
            <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
              {
                isEnglish ? (
                  <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                    Phone
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                    电话
                  </PingFangRegularText>
                )
              }
              <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
                +61 {phoneNumber.substring(2)}
              </SquadBoldText>
            </div>
          )
        }
        {
          !phoneNumber && (
            <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
              {
                isEnglish ? (
                  <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                    Unit No.
                  </SquadRegularText>
                ) : (
                  <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                    门牌号
                  </PingFangRegularText>
                )
              }
              <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
                {roomNo}
              </SquadBoldText>
            </div>
          )
        }
        <div style={{ width: contentWidth * 0.9, marginTop: 15 }}>
          {
            isEnglish ? (
              <SquadRegularText fontSize={16} lineHeight={19} opacity={0.4}>
                Location
              </SquadRegularText>
            ) : (
              <PingFangRegularText fontSize={16} lineHeight={22} opacity={0.4}>
                地点
              </PingFangRegularText>
            )
          }
          <SquadBoldText fontSize={16} lineHeight={21} marginTop={3}>
            {location}
          </SquadBoldText>
        </div>

        <div style={{ width: contentWidth * 0.9, height: 1, backgroundColor: '#11202B', opacity: 0.1, marginTop: 15 }} />

        {/* Okay按钮 */}
        <RowBetween style={{ width: contentWidth * 0.9, marginTop: 15, marginBottom: 15 }}>
          <Button
            width={contentWidth * 0.43}
            height={38}
            backgroundColor={'#00B595'}
            borderRadius={60}
            onClick={() => callback()}
          >
            {
              isEnglish ? (
                <SquadBoldText fontSize={18} color={'#FFFFFF'}>
                  Confirm
                </SquadBoldText>
              ) : (
                <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                  确认
                </PingFangSemiBoldText>
              )
            }
          </Button>
          <Button
            width={contentWidth * 0.43}
            height={38}
            backgroundColor={'#F44336'}
            borderRadius={60}
            onClick={() => onClose()}
          >
            {
              isEnglish ? (
                <SquadBoldText fontSize={18} color={'#FFFFFF'}>
                  Change
                </SquadBoldText>
              ) : (
                <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                  更改
                </PingFangSemiBoldText>
              )
            }
          </Button>
        </RowBetween>
      </ColumnCenter>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  callback: () => void;
  isEnglish: boolean;
  userName: string;
  phoneNumber?: string;
  roomNo: string;
  location: string
}

export default ConfirmUserModal;
